import { defineComponent as _defineComponent } from 'vue'
import AboutApp from '@/components/AboutApp.vue'
import { useUtil } from '@/plugins/util'
import { useRouter } from '@/router'
import { useAuthStore } from '@/store/pinia/auth'
import { usePhysicianStore } from '@/store/pinia/physician'
import AppMenuButton from '@/v2/components/ui/menu/AppMenuButton.vue'
import { vOnClickOutside } from '@vueuse/components'
import dayjs from 'dayjs'
import { computed, getCurrentInstance, onBeforeMount, ref } from 'vue'
import Teleport from 'vue2-teleport'
import DigitalSignatureAuthModal from '../../medical-document/DigitalSignatureAuthModal.vue'
import SwitchOnOff from '../../ui/SwitchOnOff.vue'
import AppIcon from '../../ui/icon/AppIcon.vue'
import RoundedUserAvatar from './RoundedUserAvatar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DropMenuContent',
  emits: ["close"],
  setup(__props, { emit }) {

const authStore = useAuthStore()
const router = useRouter()

const userName = ref<string>()

const digitalSignature = ref({
  open: false,
  authenticated: false,
})



const util = useUtil()
const physicianStore = usePhysicianStore()
function handleClick(button: string, callback: () => void | Promise<void>) {
  const analytics = util.prepareSegment()
  const userData = util.prepareSegmentUserProperties(physicianStore)

  analytics.track('Clique no header', {
    button: button,
    buttonTitle: button,
    ...userData,
  })

  return callback()
}

function goToPage(routeName: string) {
  router.push({ name: routeName })
  emit('close', false)
}

async function toggleDigitalSignatureAuth() {
  if (!authStore.digitalSignatureToken.token && !digitalSignature.value.authenticated) {
    digitalSignature.value.open = true
  } else {
    digitalSignature.value.authenticated = !digitalSignature.value.authenticated
    await authStore.setDigitalSignatureAuthentication(digitalSignature.value.authenticated)
  }
}

const componentKey = ref<number>(0)

async function finishAuthentication(token: string, expiresAt: Date) {
  authStore.setDigitalSignatureToken(token, expiresAt, true)

  digitalSignature.value.authenticated = true

  componentKey.value++
}

const vm = getCurrentInstance()
const root = computed(() => vm?.proxy.$root)

async function logout() {
  if (root.value && (await root.value.confirm('Deseja realmente sair do sistema?'))) {
    try {
      await authStore.logout()
    } catch (error) {
      console.error(error)
    } finally {
      emit('close', false)
    }
  }
}
function handleOutsideClick() {
  emit('close', digitalSignature.value.open)
}

async function getUsername() {
  userName.value = authStore.session?.user.name
}

onBeforeMount(() => {
  getUsername()

  const { expiresAt } = authStore.digitalSignatureToken

  if (!expiresAt) {
    digitalSignature.value.authenticated = false
    return
  }

  if (dayjs().isAfter(expiresAt)) {
    authStore.setDigitalSignatureToken(null, null, false)

    digitalSignature.value.authenticated = false
  } else {
    digitalSignature.value.authenticated = authStore.digitalSignatureToken.authenticated
  }
})

return { __sfc: true,authStore, router, userName, digitalSignature, emit, util, physicianStore, handleClick, goToPage, toggleDigitalSignatureAuth, componentKey, finishAuthentication, vm, root, logout, handleOutsideClick, getUsername, AboutApp, AppMenuButton, vOnClickOutside, Teleport, DigitalSignatureAuthModal, SwitchOnOff, AppIcon, RoundedUserAvatar }
}

})